var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"switch-button",on:{"click":function($event){return _vm.$emit('action')}}},[_c('div',{staticClass:"label"},[_vm._t("default")],2),_c('SwitchHandle',{attrs:{"on":_vm.on}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }